/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Metrics_admin = {|
  +metrics: {|
    +timeBased: ?{| |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Metrics_admin",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Metrics",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TimeBasedMetric",
          "name": "timeBased",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "TimeBasedChart_timeBased",
              "args": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "Activity_metrics",
          "args": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Admin"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/home/__generated__/Metrics_admin.graphql.js